import { SpintrTypes } from "src/typings";
import { ShareTargetType } from "./ShareModal.types";

export interface IShareTargetTypeConfig {
    // Language key for the dynamic info text shown in the modal body.
    infoTextKey: string;
    // Language key for the "what happens on share" description on each dropdown row.
    descriptionKey: string;
    // Whether the message textarea is shown for this target type.
    showTextarea: boolean;
    // Optional Visage2 icon used when the target has no avatar image (feed/group/department).
    iconName?: string;
}

// Single source of truth for the data-driven share flow.
export const shareTargetConfig: Record<ShareTargetType, IShareTargetTypeConfig> = {
    feed: {
        infoTextKey: "SHARE_INFO_FEED",
        descriptionKey: "SHARE_DESC_FEED",
        showTextarea: true,
        iconName: "global",
    },
    user: {
        infoTextKey: "SHARE_INFO_USER",
        descriptionKey: "SHARE_DESC_USER",
        showTextarea: true,
    },
    group: {
        infoTextKey: "SHARE_INFO_GROUP",
        descriptionKey: "SHARE_DESC_GROUP",
        showTextarea: true,
        iconName: "people",
    },
    department: {
        infoTextKey: "SHARE_INFO_DEPARTMENT",
        descriptionKey: "SHARE_DESC_DEPARTMENT",
        showTextarea: true,
        iconName: "buildings-2",
    },
};

// Maps an UberType (as returned by /api/v1/targets and /api/v1/share/recent) to the
// data-driven ShareTargetType. Returns null for types that cannot be shared to.
export function uberTypeToShareTargetType(type: number): ShareTargetType | null {
    switch (type) {
        case SpintrTypes.UberType.User:
            return "user";
        case SpintrTypes.UberType.Group:
            return "group";
        case SpintrTypes.UberType.Department:
            return "department";
        default:
            return null;
    }
}
